export default __webpack_public_path__ + "static/media/640_store01-es-mobile.43a3cc68.png";